<template>
  <div class="">
    <div class="update_wrap">
        <div class="update_info">
            <span>
                刷新时间：{{nowDate}}
            </span>
            <img src="../../assets/img/update_btn.png" @click="getData" alt="">
        </div>
    </div>
    <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
        <tr>
            <th>{{statistics.pointName}}</th>
            <th>{{statistics.value}}</th>
        </tr>
    </table>
  </div>
</template>
<script>
import { getDate } from '@/assets/js/index.js';
// 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
export default {
  name:"",    
  data: () => ({
    nowDate: null,
    statistics: [],
  }),
  props: ['partId'],
  components: {

  },
  created() {

  },
  mounted() {
    this.getData();
  },
  computed: {

  },
  methods: {
    //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
    getData(){
        this.nowDate = getDate(new Date().getTime(), 'year');;
        this.statistics = [];
        
        let url = '/mcbw/network_monitor/pointNowValue/' + this.partId;
        let _this = this;
        var data = {
            type: 'get',
            url: url,
            obj: {
                orgId: this.$store.state.baseInfoLayer.baseInfoId,
                type: 'ddl',
            }
        };
        _this.$Axios(data).then((res)=>{
            console.log(res);
            console.log('电池电量数据');
            
            if(res.data.success){
                if(Object.keys(res.data.data).length){
                    this.statistics = res.data.data[0];
                }
            }
        });
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .ivu-table th,
/deep/ .ivu-table td{
    text-align: center;
} 
table{
    width: 100%
}
.update_wrap{
    display: flex;
    justify-content: flex-end;
    .update_info{
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
            margin-right: 10px;
        }
        img{
            width: 16px;
            height: 16px;
            cursor: pointer;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/detector/ddl.vue